import { useDragLayer } from 'react-dnd';

import { COLUMN_DND_TYPE, type ColumnDragItem } from '@/features/policies-comparison';

export function useDragMonitor() {
  return useDragLayer(monitor => {
    const itemType = monitor.getItemType();
    if (!monitor.isDragging() || itemType !== COLUMN_DND_TYPE) {
      return { draggedId: null };
    }
    const item = monitor.getItem() as ColumnDragItem | null;
    return { draggedId: item?.fundingSourceId ?? null };
  });
}
